import types from './mutations-types';

const mutations = {
  [types.SET_DATES](state, payload) {
    state.calendarDates = {
      ...payload,
    };
  },
  [types.SET_DEFAULT_DATES](state) {
    state.calendarDates.start = null;
    state.calendarDates.end = null;
    state.calendarDates.selected = null;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/calendar/mutations.js